import { createAction, createRequestTypes, createRequestAction } from 'utils'

export const LOAD_SYSTEMS = '@system/LOAD_SYSTEMS'
export const LOAD_SYSTEM = '@system/LOAD_SYSTEM'
export const POLL_SYSTEMS_START = '@system/POLL_SYSTEMS_START'
export const POLL_SYSTEMS_STOP = '@system/POLL_SYSTEMS_STOP'
export const LOAD_LAST_VERSIONS = '@system/LOAD_LAST_VERSIONS'
export const DELETE_SYSTEM = '@system/DELETE_SYSTEM'
export const DELETE_SYSTEMS = '@system/DELETE_SYSTEMS'
export const DELETE_SYSTEM_DATA = '@system/DELETE_SYSTEM_DATA'
export const DELETE_SYSTEM_FROM_USER = '@system/DELETE_SYSTEM_FROM_USER'
export const UPDATE_RESET_SYSTEM = '@system/UPDATE_RESET_SYSTEM'
export const UPDATE_DEVICE_NAME = '@system/UPDATE_DEVICE_NAME'
export const SYNC_AIRTABLE = '@system/SYNC_AIRTABLE'
export const ADD_DEVICE_TO_USER = '@system/ADD_DEVICE_TO_USER'
export const CREATE_API_KEY = '@system/CREATE_API_KEY'
export const DELETE_API_KEY = '@system/DELETE_API_KEY'
export const SET_API_KEY_STATUS = '@system/SET_API_KEY_STATUS'

export const LOAD_SYSTEMS_REQUEST = createRequestTypes('system/LOAD_SYSTEMS_REQUEST')
export const POLL_SYSTEMS_REQUEST = createRequestTypes('system/POLL_SYSTEMS_REQUEST')
export const LOAD_SYSTEM_REQUEST = createRequestTypes('system/LOAD_SYSTEM_REQUEST')
export const LOAD_LAST_VERSIONS_REQUEST = createRequestTypes('system/LOAD_LAST_VERSIONS_REQUEST')
export const DELETE_SYSTEM_REQUEST = createRequestTypes('system/DELETE_SYSTEM_REQUEST')
export const DELETE_SYSTEM_DATA_REQUEST = createRequestTypes('system/DELETE_SYSTEM_DATA_REQUEST')
export const DELETE_SYSTEM_FROM_USER_REQUEST = createRequestTypes(
  'system/DELETE_SYSTEM_FROM_USER_REQUEST'
)
export const DELETE_SYSTEMS_REQUEST = createRequestTypes('system/DELETE_SYSTEM_REQUEST')
export const UPDATE_RESET_SYSTEM_REQUEST = createRequestTypes('system/UPDATE_RESET_SYSTEM_REQUEST')
export const UPDATE_DEVICE_NAME_REQUEST = createRequestTypes('system/UPDATE_DEVICE_NAME_REQUEST')
export const SYNC_AIRTABLE_REQUEST = createRequestTypes('system/SYNC_AIRTABLE_REQUEST')
export const ADD_DEVICE_TO_USER_REQUEST = createRequestTypes('system/ADD_DEVICE_TO_USER_REQUEST')
export const CREATE_API_KEY_REQUEST = createRequestTypes('@system/CREATE_API_KEY_REQUEST')
export const DELETE_API_KEY_REQUEST = createRequestTypes('@system/DELETE_API_KEY_REQUEST')
export const SET_API_KEY_STATUS_REQUEST = createRequestTypes('@system/SET_API_KEY_STATUS_REQUEST')

export const constants = {
  LOAD_SYSTEMS,
  LOAD_SYSTEM,
  POLL_SYSTEMS_START,
  POLL_SYSTEMS_STOP,
  LOAD_LAST_VERSIONS,
  DELETE_SYSTEM,
  DELETE_SYSTEMS,
  DELETE_SYSTEM_DATA,
  DELETE_SYSTEM_FROM_USER,
  UPDATE_RESET_SYSTEM,
  UPDATE_DEVICE_NAME,
  SYNC_AIRTABLE,
  ADD_DEVICE_TO_USER,
  CREATE_API_KEY,
  DELETE_API_KEY,
  SET_API_KEY_STATUS,

  LOAD_SYSTEMS_REQUEST,
  LOAD_SYSTEM_REQUEST,
  POLL_SYSTEMS_REQUEST,
  LOAD_LAST_VERSIONS_REQUEST,
  DELETE_SYSTEM_REQUEST,
  DELETE_SYSTEMS_REQUEST,
  DELETE_SYSTEM_DATA_REQUEST,
  DELETE_SYSTEM_FROM_USER_REQUEST,
  UPDATE_RESET_SYSTEM_REQUEST,
  UPDATE_DEVICE_NAME_REQUEST,
  SYNC_AIRTABLE_REQUEST,
  ADD_DEVICE_TO_USER_REQUEST,
  CREATE_API_KEY_REQUEST,
  DELETE_API_KEY_REQUEST,
  SET_API_KEY_STATUS_REQUEST
}

export const loadSystems = createAction(LOAD_SYSTEMS)
export const loadSystem = createAction(LOAD_SYSTEM)
export const pollSystemsStart = createAction(POLL_SYSTEMS_START)
export const pollSystemsStop = createAction(POLL_SYSTEMS_STOP)
export const loadLastVersions = createAction(LOAD_LAST_VERSIONS)
export const deleteSystem = createAction(DELETE_SYSTEM)
export const deleteSystems = createAction(DELETE_SYSTEMS)
export const deleteSystemData = createAction(DELETE_SYSTEM_DATA)
export const deleteSystemFromUser = createAction(DELETE_SYSTEM_FROM_USER)
export const updateResetSystem = createAction(UPDATE_RESET_SYSTEM)
export const updateDeviceName = createAction(UPDATE_DEVICE_NAME)
export const syncAirtable = createAction(SYNC_AIRTABLE)
export const addDeviceToUser = createAction(ADD_DEVICE_TO_USER)
export const createApiKey = createAction(CREATE_API_KEY)
export const deleteApiKey = createAction(DELETE_API_KEY)
export const setApiKeyStatus = createAction(SET_API_KEY_STATUS)

export const loadSystemsRequest = createRequestAction(LOAD_SYSTEMS_REQUEST)
export const pollSystemsRequest = createRequestAction(POLL_SYSTEMS_REQUEST)
export const loadSystemRequest = createRequestAction(LOAD_SYSTEM_REQUEST)
export const loadLastVersionsRequest = createRequestAction(LOAD_LAST_VERSIONS_REQUEST)
export const deleteSystemRequest = createRequestAction(DELETE_SYSTEM_REQUEST)
export const deleteSystemsRequest = createRequestAction(DELETE_SYSTEMS_REQUEST)
export const deleteSystemDataRequest = createRequestAction(DELETE_SYSTEM_DATA_REQUEST)
export const deleteSystemFromUserRequest = createRequestAction(DELETE_SYSTEM_FROM_USER_REQUEST)
export const updateResetSystemRequest = createRequestAction(UPDATE_RESET_SYSTEM_REQUEST)
export const updateDeviceNameRequest = createRequestAction(UPDATE_DEVICE_NAME_REQUEST)
export const syncAirtableRequest = createRequestAction(SYNC_AIRTABLE_REQUEST)
export const addDeviceToUserRequest = createRequestAction(ADD_DEVICE_TO_USER_REQUEST)
export const createApiKeyRequest = createRequestAction(CREATE_API_KEY_REQUEST)
export const deleteApiKeyRequest = createRequestAction(DELETE_API_KEY_REQUEST)
export const setApiKeyStatusRequest = createRequestAction(SET_API_KEY_STATUS_REQUEST)

export default {
  loadSystems,
  loadSystem,
  pollSystemsStart,
  pollSystemsStop,
  loadLastVersions,
  deleteSystem,
  deleteSystems,
  deleteSystemData,
  deleteSystemFromUser,
  updateResetSystem,
  updateDeviceName,
  syncAirtable,
  addDeviceToUser,
  createApiKey,
  deleteApiKey,
  setApiKeyStatus,

  loadSystemsRequest,
  loadSystemRequest,
  pollSystemsRequest,
  loadLastVersionsRequest,
  deleteSystemRequest,
  deleteSystemsRequest,
  deleteSystemDataRequest,
  deleteSystemFromUserRequest,
  updateResetSystemRequest,
  updateDeviceNameRequest,
  syncAirtableRequest,
  addDeviceToUserRequest,
  createApiKeyRequest,
  deleteApiKeyRequest,
  setApiKeyStatusRequest
}
